var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#347EF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 32H59.8C59.3358 29.7428 58.1076 27.7147 56.3225 26.2574C54.5374 24.8002 52.3044 24.0029 50 24L46 24C43.6956 24.0029 41.4626 24.8002 39.6775 26.2574C37.8924 27.7147 36.6642 29.7428 36.2 32H30C29.4696 32 28.9609 32.2107 28.5858 32.5858C28.2107 32.9609 28 33.4696 28 34C28 34.5304 28.2107 35.0391 28.5858 35.4142C28.9609 35.7893 29.4696 36 30 36H32V62C32.0032 64.6512 33.0578 67.1929 34.9324 69.0676C36.8071 70.9422 39.3488 71.9968 42 72H54C56.6512 71.9968 59.1929 70.9422 61.0676 69.0676C62.9422 67.1929 63.9968 64.6512 64 62V36H66C66.5304 36 67.0391 35.7893 67.4142 35.4142C67.7893 35.0391 68 34.5304 68 34C68 33.4696 67.7893 32.9609 67.4142 32.5858C67.0391 32.2107 66.5304 32 66 32V32ZM46 28H50C51.2405 28.0015 52.4503 28.3868 53.4632 29.1029C54.4762 29.819 55.2428 30.831 55.658 32H40.342C40.7572 30.831 41.5238 29.819 42.5368 29.1029C43.5497 28.3868 44.7595 28.0015 46 28V28ZM60 62C60 63.5913 59.3679 65.1174 58.2426 66.2426C57.1174 67.3679 55.5913 68 54 68H42C40.4087 68 38.8826 67.3679 37.7574 66.2426C36.6321 65.1174 36 63.5913 36 62V36H60V62Z",
    fill: "#347EF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60C44.5304 60 45.0391 59.7893 45.4142 59.4142C45.7893 59.0391 46 58.5304 46 58V46C46 45.4696 45.7893 44.9609 45.4142 44.5858C45.0391 44.2107 44.5304 44 44 44C43.4696 44 42.9609 44.2107 42.5858 44.5858C42.2107 44.9609 42 45.4696 42 46V58C42 58.5304 42.2107 59.0391 42.5858 59.4142C42.9609 59.7893 43.4696 60 44 60Z",
    fill: "#347EF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 60C52.5304 60 53.0391 59.7893 53.4142 59.4142C53.7893 59.0391 54 58.5304 54 58V46C54 45.4696 53.7893 44.9609 53.4142 44.5858C53.0391 44.2107 52.5304 44 52 44C51.4696 44 50.9609 44.2107 50.5858 44.5858C50.2107 44.9609 50 45.4696 50 46V58C50 58.5304 50.2107 59.0391 50.5858 59.4142C50.9609 59.7893 51.4696 60 52 60Z",
    fill: "#347EF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiDelete);
export default __webpack_public_path__ + "static/media/ai-delete.52fb6cde503bc31f2e5cbf3a8d1595c0.svg";
export { ForwardRef as ReactComponent };